import { Collection } from 'modules/core/lib/mobx-rest'

import OverlapPeriod from 'modules/work_schedules/store/models/OverlapPeriod'

export class OverlapPeriods extends Collection<OverlapPeriod> {
  model() {
    return OverlapPeriod
  }

  getNonDefaultPeriods(id: number): OverlapPeriod[] {
    return this.models.filter(
      (period) => period.get('schedule_id') === id && !period.toJS().default
    )
  }

  getDefaultPeriod(id: number): OverlapPeriod | null | undefined {
    return this.models.find((period) => period.get('schedule_id') === id && period.toJS().default)
  }
}

const singleton: OverlapPeriods = new OverlapPeriods()

export default singleton
